"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentRelationsExporter = void 0;
var tslib_1 = require("tslib");
var numberings_1 = require("../numberings");
var relation_collection_1 = require("./relation-collection");
var DocumentRelationsExporter = (function (_super) {
    tslib_1.__extends(DocumentRelationsExporter, _super);
    function DocumentRelationsExporter(data) {
        var _this = _super.call(this, data, 'word/_rels/document.xml.rels') || this;
        _this.headerRelationsTable = {};
        _this.footerRelationsTable = {};
        _this.footNoteRelationsTable = {};
        _this.endNoteRelationsTable = {};
        _this.commentRelationsTable = {};
        _this.commentsExtendedRelationsTable = {};
        return _this;
    }
    DocumentRelationsExporter.prototype.fillWriter = function () {
        _super.prototype.fillWriter.call(this);
        this.generateFileRelationCore(this.headerRelationsTable, this.data.constants.rels.relsHeader);
        this.generateFileRelationCore(this.footerRelationsTable, this.data.constants.rels.relsFooter);
        this.generateFileRelationCore(this.footNoteRelationsTable, this.data.constants.rels.relsFootNote);
        this.generateFileRelationCore(this.endNoteRelationsTable, this.data.constants.rels.relsEndNote);
        this.generateFileRelationCore(this.commentsExtendedRelationsTable, this.data.constants.rels.relsCommentsExtended);
        this.generateFileRelationCore(this.commentRelationsTable, this.data.constants.rels.relsComment);
        this.addRel('RelStyle1', this.data.constants.rels.officeStylesType, 'styles.xml');
        if (this.data.model.webSettings.isBodyMarginsSet())
            this.addRel('RelWebSettings1', this.data.constants.rels.officeWebSettingsType, 'webSettings.xml');
        if (numberings_1.NumberingsExporter.shouldExportNumbering(this.data.model))
            this.addRel('RelNum1', this.data.constants.rels.officeNumberingType, 'numbering.xml');
        this.addRel('RelSettings1', this.data.constants.rels.officeDocumentSettings, 'settings.xml');
        this.addRel('RelTheme1', this.data.constants.rels.officeThemesType, 'theme/theme1.xml');
    };
    return DocumentRelationsExporter;
}(relation_collection_1.RelationCollectionExporter));
exports.DocumentRelationsExporter = DocumentRelationsExporter;
